<template>
  <div class="about">
    <br>
    <ATitle text="展馆概况"></ATitle>
    <br>
    <div class="ex-info center">
      <p style="text-align: justify">    第六届博览会展馆面积约4万平方米，现场设置“5+4+X”展览矩阵，即“5”大主题馆、“4”个特色展示区、“X”项配套活动。“5”大主题馆包含公路轨道馆、航空产业（低空经济）馆、港航物流（航运服务）馆、数字交通馆、绿色低碳馆；“4”个特色展区包含“交通+”展示区、“双循环”交通物流展示区、交通创新集成展示区、交享生活展示区。</p>
    </div>
    <div style="background: url('//itie-static.oss-cn-hangzhou.aliyuncs.com/assets/exhibition_bg.png') no-repeat scroll left / 100%">
      <CTitle text="场馆布局"/>
      <div class="tc"><img style="width: 866px" src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E5%9C%BA%E9%A6%86%E5%9B%BE%E4%BE%8B/%E5%9C%BA%E9%A6%86%E5%B8%83%E5%B1%802024.png"></div>
      <br>
      <CTitle text="主题展示馆"/>
      <div class="flex ex-wrap center">
        <div class="ex-item" v-for="(item,index) in exList" :key="index">
          <div class="front">
            <div class="inner">
              <div class="flex img">
                <img :src="item.img" :style="item.style">
              </div>
              <div class="text">{{item.title}}</div>
            </div>
            <div class="line"></div>
          </div>
          <div class="back">
            <div class="inner">
              <div class="info">
                <br>
                {{item.info}}
              </div>
              <!-- <div class="location">
                <img src="data:image/png;base64,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">
                {{item.location}}
              </div> -->
              <div class="text">{{item.title}}</div>
            </div>
            <div class="line"></div>
          </div>
        </div>
      </div>
      <br>
      <CTitle text="特色展示区"/>
      <div class="area-wrap">
        <div v-for="(item, index) in areaList" :key="index" class="flex area">
          <div class="name">{{ item.title }}</div>
          <div class="f1">{{ item.info }}</div>
        </div>
      </div>
    </div>
    <br>
    <!-- <CTitle text="展馆亮点"/>
    <br>
    <div class="spot-wrap">
      <div class="flex center" style="border-bottom: 1px solid #ECECEC;">
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot1.png">
          </div>
          <div class="text">
            <h1>推进交通强国建设试点工作</h1>
            <p>浙江将着眼打造一批全国领先、具有标志性和引领性的重大项目。第三届博览会聚焦稳经济稳增长，抢抓政策机遇，加快建设高水平交通强省，聚焦建设“重要窗口”，更好发挥先行官作用。</p>
          </div>
        </div>
        <div class="v-line"></div>
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot2.png">
          </div>
          <div class="text">
            <h1>打造交通强省建设解决方案的资源库</h1>
            <p>今年作为交通强省建设打基础的关键之年，第三届博览会紧紧围绕国家和省委省政府重大战略部署，为交通强省建设提供高水平合作交流的平台，打造“交通强省”金名片。</p>
          </div>
        </div>
      </div>
      <div class="flex center" style="border-bottom: 1px solid #ECECEC;">
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot3.png">
          </div>
          <div class="text">
            <h1>以平台建设推动产业发展</h1>
            <p>经过两届的打造，博览会成为浙江综合交通产业对接、政策交流、项目孵化的优质平台，逐步成为国内外知名企业重点参与展会，为我省综合交通产业发展提供无限潜能。</p>
          </div>
        </div>
        <div class="v-line"></div>
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot4.png">
          </div>
          <div class="text">
            <h1>省级综交产业示范园区全景呈现</h1>
            <p>集中展现智慧交通科技园、未来交通小镇等省级示范园区的发展规划、创新成果、产业特色、招商政策等特色性内容。</p>
          </div>
        </div>
      </div>
      <div class="flex center" style="border-bottom: 1px solid #ECECEC;">
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot5.png">
          </div>
          <div class="text">
            <h1>重量级嘉宾引领行业方向</h1>
            <p>围绕行业发展热门话题，设置多个主题论坛，拟邀请发改、经信、交通、科技等单位重要领导，国内外知名专家，企业高管参与博览会并做主题演讲，汇聚综合交通产业发展最权威声音、最新锐思想。</p>
          </div>
        </div>
        <div class="v-line"></div>
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot6.png">
          </div>
          <div class="text">
            <h1>展会权威性日益增强</h1>
            <p>展会作为综合交通产业的重要载体和有力推手，平台联动效益持续放大，影响力不断扩大，获得交通运输部、人力社保部、全国总工会、共青团中央等权威指导与支持。</p>
          </div>
        </div>
      </div>
      <div class="flex center" style="border-bottom: 1px solid #ECECEC;">
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot7.png">
          </div>
          <div class="text">
            <h1>聚焦永不落幕的数字化展示窗口</h1>
            <p>通过“云上展”、“云推荐”、“云直播”、“云发布”、“云服务”五大板块，加速博览会数字化步伐。</p>
          </div>
        </div>
        <div class="v-line"></div>
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot8.png">
          </div>
          <div class="text">
            <h1>展会规模同类最大</h1>
            <p>展会实现综合交通产业重点领域全履盖，在往届博览会基础上，进一步精准聚焦，重点吸引国际性企业中国区分公司参与，重点提升国内龙头企业、独角兽企业参展比例。</p>
          </div>
        </div>
      </div>
      <div class="flex center" style="border-bottom: 1px solid #ECECEC;">
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot9.png">
          </div>
          <div class="text">
            <h1>专题展品细分覆盖全产业链</h1>
            <p>深度结合市场发展和技术发展趋势，结合培育产业集群的实际需求，展示高端装备、智慧交通、绿色交通等综合交通产业相关新兴领域的新技术、新产品及最新解决方案。</p>
          </div>
        </div>
        <div class="v-line"></div>
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot10.png">
          </div>
          <div class="text">
            <h1>交通黑科技集中发布</h1>
            <p>实体展示航空航天、轨道交通、先进智能机械等最新装载装备，展示体现新理念、新材料、新工艺的新产品，联合国内外龙头企业现场发布最新交通领域技术成果。</p>
          </div>
        </div>
      </div>
      <div class="flex center" style="border-bottom: 1px solid #ECECEC;">
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot11.png">
          </div>
          <div class="text">
            <h1>全面提高配套活动层次</h1>
            <p>同期举办2020年全国行业职业技能竞赛—第十二届全国交通运输行业职业技能大赛闭幕式、第二届综合交通创新创业大赛等同期配套活动，展会国际影响力、行业影响力、创新影响力显著提升。</p>
          </div>
        </div>
        <div class="v-line"></div>
        <div class="spot">
          <div class="fl flex img">
            <img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E4%BA%AE%E7%82%B9%E5%9B%BE%E6%A0%87/spot12.png">
          </div>
          <div class="text">
            <h1>扩大媒体深度报道影响力</h1>
            <p>持续扩大前两届博览会成功举办的溢出效应、口碑效应。在媒体关注度的基础上逐步升温，实现第三届博览会媒体宣传再上新台阶。</p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      exList: [
        {
          title: '公路轨道馆',
          info: '重点展示交通建筑工业化、公路建设管理相关设施设备，轨道交通的技术发展趋势和全产业链生态，涵盖国内外轨道交通及铁路机车车辆设备及零部件、机电设备等。',
          img: '//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/展馆logo/exhibition-area-2021-1.png',
          location: '展馆位于3B-A',
          // style: {
          //   width: '270px'
          // }
        },{
          title: '航空产业（低空经济）馆',
          info: '重点展示航空智能制造技术与装备及零部件创新应用，涵盖航空新材料新技术与设备、智慧机场智能化设备、低空智能产业，临空经济区等。',
          img: '//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/展馆logo/exhibition-area-2021-2.png',
          location: '展馆位于3C-D',
        },{
          title: '港航物流（航运服务）馆',
          info: '展示现代航运服务、多式联运、港航科技、供应链产业、物流信息服务平台、港口管理及配套产业。',
          img: '//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/展馆logo/exhibition-area-2021-3.png',
          location: '展馆位于3C-C',
        },{
          title: '数字交通馆',
          info: '聚焦基础设施数字化转型升级，展示数字交通应用场景及解决方案；覆盖“数据+交通”驱动下的智慧公路、智慧港口、智慧轨道、智慧航空等联动创新应用场景。',
          img: '//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/展馆logo/exhibition-area-2021-5.png',
          location: '展馆位于3B-B'
        },{
          title: '绿色低碳馆',
          info: '聚焦绿色交通运输、智能物流、物流装备、绿色仓储、能源和信息服务，展示物流绿色化、低碳化、现代化领域的新技术、新产品、新模式、新业态供应链服务。',
          img: '//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/展馆logo/exhibition-area-2021-4.png',
          location: '展馆位于3D-G'
        }
      ],
      areaList: [
        {
          title: '“交通+”展示区',
          info: '由杭州、湖州、舟山、台州、丽水5市牵头、市县联合参展，重点展示以“四好农村路”为核心的“交通+文化旅游”“交通+乡村振兴”“交通+特色产业”等场景。'
        },
        {
          title: '“双循环”交通物流展示区',
          info: '设置“1+3”模块，“1”为“一 带一路”多式联运服务平台，展示中欧班列+海铁联运等内容，“3”为航空、商贸物流、港口等 3 大主题展示区。'
        },
        {
          title: '交通创新集成展示区',
          info: '设置交通科技创新、专精特新2大板块， 交通科技创新板块展示交通科创平台成果;专精特新板块首次探索以市场化方式，展示省内外创新企业成果。'
        },
        {
          title: '交享生活展示区',
          info: '设置环浙骑游互动区、交通文创集等，环浙骑游互动区展示皮娜、梅花、闪电等10余个环法赛事冠军品牌，并设置骑行互动体验;交通文创集包括交通主题邮展、文 创市集、声音小邮局体验等。'
        },
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.about {
  background: url('../assets/views_bg.png') no-repeat scroll bottom / 100%;
  .ex-info {
    padding: 0 40px;
    p {
      font-size: 16px;
      text-indent: 30px;
      color: #333;
      line-height: 30px;
    }
  }
  .ex-wrap {
    padding: 20px 0;
    padding-bottom: 100px;
    justify-content: center;
    flex-wrap: wrap;
    .ex-item {
      width: 240px;
      height: 300px;
      border-radius: 8px;
      margin: 20px 30px;
      transform-style: preserve-3d;
      perspective: 1000px;
      .front, .back {
        border: 1px solid rgba(7, 105, 204, 0.5);
        border-radius: 4px;
        transition: transform 0.8s cubic-bezier(0.4, 0.2, 0.2, 1);
        -ms-transition: transform 0s cubic-bezier(0.4, 0.2, 0.2, 1);
        backface-visibility: hidden;
        height: 309px;
        text-align: center;
        transform-style: preserve-3d;
        .line {
          margin-top: 224px;
          height: 83px;
          line-height: 83px;
          background: #BDDEFF;
          border-bottom-left-radius: 3px;
          border-bottom-right-radius: 3px;
        }
      }
      .front {
        transform: rotateY(0deg);
        background: #F1F8FF;
        img {
          max-width: 180px;
        }
      }
      .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background: #0769CC;
        transform: rotateY(180deg);
        .inner {
          width: 100%;
          text-align: justify;
          .text {
            text-align: center;
            color: #0061C4;
          }
        }
        .location {
          color: #FFF;
          position: absolute;
          width: 100%;
          top: 169px;
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 2px;
          img {
            position: relative;
            top: 8px;
            width: 20px;
            max-height: 300px;
            margin-left: 20px;
            margin-right: 6px;
          }
        }
      }
      .inner {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        transform: translateY(-50%) translateZ(50px) scale(0.94);
        box-sizing: border-box;
        perspective: inherit;
        z-index: 2;
        .img, .info {
          height: 224px;
        }
        .info {
          font-size: 16px;
          font-weight: 400;
          padding: 0 20px;
          color: #FFF;
        }
        .text {
          font-size: 20px;
          font-weight: 500px;
          height: 85px;
          line-height: 85px;
          color: #0061C4;
        }
      }
    }
    .ex-item:hover {
      .front, .back {
        transition: transform 0.8s cubic-bezier(0.4, 0.2, 0.2, 1);
        -ms-transition: transform 0s cubic-bezier(0.4, 0.2, 0.2, 1);
        transform-style: preserve-3d;
      }
      .front {
        transform: rotateY(-180deg);
      }
      .back {
        transform: rotateY(0deg);
      }
    }
  }
  .area-wrap {
    width: 1000px;
    margin: 0 auto 100px;
    .area {
      justify-content: flex-start;
      font-size: 16px;
      background-color: #F1F8FF;
      border: 1px solid rgba(7, 105, 204, 0.5);
      margin-bottom: 16px;
      .name, .f1 {
        padding: 12px;
      }
      .name {
        flex-shrink: 0;
        height: 74px;
        padding: 26px 12px;
        width: 210px;
        color: #0061C4;
        background-color: #BDDEFF;
      }
    }
  }
  .spot-wrap {
    // background: url('../assets/maze_bg.svg') repeat-x;
    height: 1200px;
    .center {
      justify-content: space-around;
      flex-wrap: wrap;
      .v-line {
        width: 1px;
        background: #ECECEC;
        height: 150px;
      }
      .spot {
        width: 470px;
        height: 150px;
        margin: 15px 0;
        .img {
          width: 70px;
          height: 160px;
          img {
            width: 60px;
            height: auto;
          }
        }
        .text {
          padding-left: 80px;
          h1 {
            font-size: 23px;
            color: #0769CC;
            letter-spacing: 1px;
            line-height: 40px;
          }
          p {
            font-size: 16px;
            color: #666;
            text-align: justify;
          }
        }
      }
    }
  }
}
</style>
